import { gql } from "@apollo/client";

export function buildCompanyListQuery(opts: {
  hasCompetitorPresence?: boolean;
  hasMatchFile?: boolean;
}) {
  return gql`
    query getCompanyList(
      $filters: OpportunityGeneratorFilter
      $localizeInstalls: Boolean
      $page: Int!
      $per: Int!
      $sort: [Sort]!
      $competitorPresence: [Int!]
      $companyMatchFile: CompanyMatchFilter
    ) {
      opportunity_generator_search(
        filters: $filters
        localizeInstalls: $localizeInstalls
        page: $page
        per: $per
        sort: $sort
        competitorPresence: $competitorPresence
        companyMatchFile: $companyMatchFile
      ) {
        data {
          hgId
          name
          url
          countryName
          employeeRange {
            min
            max
          }
          revenueRange {
            min
            max
          }
          itSpend
          ${opts.hasCompetitorPresence ? "competitorPresence" : ""}
          isGhq
          isDp
          isGp
          ${opts.hasMatchFile ? "isWhitespace" : ""}
          ${opts.hasMatchFile ? "isProspectWhitespace" : ""}
          ${opts.hasMatchFile ? "isExpansionWhitespace" : ""}
        }
        count
      }
    }
  `;
}

export const COMPANY_SEARCH_SLIM_QUERY = gql`
  query doSearch($filters: CompanyFilter, $per: Int = 5) {
    search(
      filters: $filters
      page: 0
      per: $per
      sort: [{ field: "revenue_range_min", direction: DESC }]
    ) {
      data {
        name
        hgId
        url
      }
      count
    }
  }
`;
